import { render, staticRenderFns } from "./about-us.vue?vue&type=template&id=67c4ef3a&scoped=true"
import script from "./about-us.vue?vue&type=script&lang=js"
export * from "./about-us.vue?vue&type=script&lang=js"
import style0 from "./about-us.vue?vue&type=style&index=0&id=67c4ef3a&prod&scoped=true&lang=css"
import style1 from "./about-us.vue?vue&type=style&index=1&id=67c4ef3a&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c4ef3a",
  null
  
)

export default component.exports